import React from "react";

const ProgressBar = ({ level, ratio, progressColor, progressValue, heightBar = 8 }) => {
    return (
        <div
            style={{
                width: "100%",
                marginBottom: 10,
            }}
        >
            {typeof level !== "undefined" ? (
                <div style={{ marginBottom: 5 }}>
                    <div style={styles.valueLeft}>{level}</div>
                    <div style={styles.valueRight}>{progressValue}%</div>
                </div>
            ) : null}
            <div style={styles.bar(heightBar)}></div>
            <div style={styles.progress(progressValue, progressColor, heightBar)}>
                {/* <span style={{padding:'2px', fontSize:'14px', fontWeight:'500'}}>{progressValue}%</span> */}
            </div>
        </div>
    );
};

const styles = {
    bar: (heightBar) => ({
        width: "100%",
        height: heightBar,
        borderRadius: 10,
        backgroundColor: "#E9ECEF",
    }),
    progress: (progressValue, progressColor, heightBar) => ({
        width: progressValue + "%",
        marginTop: -+heightBar,
        height: heightBar,
        borderRadius: 10,
        backgroundColor: progressColor,
        textAlign: 'right',
        color: 'black'
    }),
    valueLeft: { display: "inline-block", color: "#6C757D" },
    valueRight: {
        display: "inline-block",
        float: "right",
        fontStyle: "italic",
        color: "#6C757D",
    },
};
export default ProgressBar;
